import { useEffect, useState } from "react";
import useBrowserStorage from "../../hooks/useBrowserStorage";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import Game from "../../store/Game";
import useCurrentGame from "../../hooks/useCurrentGame";
import PersonalAccount from "../../store/PersonalAccount";
import ROUTES from "../../utils/routes.js";
import game from "../../store/Game";

export default function useController() {
  const [isRulesAccepted, setIsRulesAccepted] = useState(false);
  const { getItem } = useBrowserStorage();
  const { navigateTo } = useCustomNavigate();
  const { getCurrentGame } = useCurrentGame();

  const onCheckRules = () => {
    const game = getCurrentGame();
    setIsRulesAccepted(!isRulesAccepted);
    PersonalAccount.changeRules(!isRulesAccepted);
  };
  const continueGame = async () => {
    const game = getCurrentGame();
    await PersonalAccount.addGameIdsByRules(game.id);

    navigateTo(ROUTES.MATCHES_PAGE);
  };

  useEffect(() => {
    (async () => {
      await PersonalAccount.getPersonalAccountData();
    })();
  }, []);

  return {
    onCheckRules,
    isRulesAccepted,
    continueGame,
  };
}
